// Billing Info Change Request types
export interface BillingInfoChangeRequestDto {
	Id: number;
	UserId?: number;
	UserFullName?: string;
	ApproverId?: number;
	ApproverFullName?: string;
	LegalName?: string;
	Address1?: string;
	Address2?: string;
	CityId?: number;
	CityName?: string;
	ProvinceName?: string;
	PostalCode?: string;
	Tin?: string;
	DateRequested?: string;
	DateApprovedDeclined?: string;
	Status?: string;
}

// Payment Method Change Request types
export interface PaymentMethodChangeRequestDto {
	Id: number;
	UserId?: number;
	UserFullName?: string;
	ApproverId?: number;
	ApproverFullName?: string;
	OldCardId?: number;
	OldCardLast4?: string;
	OldCardType?: string;
	NewCardTokenId?: string;
	CardType?: string;
	Last4?: string;
	ExpMonth?: number;
	ExpYear?: number;
	DateRequested?: string;
	DateApprovedDeclined?: string;
	Status?: string;
}

// Union type for displaying both request types in the same table
export type BillingRequestDto =
	| (BillingInfoChangeRequestDto & { RequestType: 'BillingInfo' })
	| (PaymentMethodChangeRequestDto & { RequestType: 'PaymentMethod' });

// Helper function to determine request type
export function isBillingInfoRequest(request: BillingRequestDto): request is BillingInfoChangeRequestDto & { RequestType: 'BillingInfo' } {
	return request.RequestType === 'BillingInfo';
}

export function isPaymentMethodRequest(request: BillingRequestDto): request is PaymentMethodChangeRequestDto & { RequestType: 'PaymentMethod' } {
	return request.RequestType === 'PaymentMethod';
}

// Request type display names
export const REQUEST_TYPE_NAMES = {
	BillingInfo: 'Update Billing Information',
	PaymentMethod: 'Update Payment Account'
} as const;

// Payment Card types
export interface PaymentCardDto {
	Id: number;
	UserId: number;
	CardType?: string;
	IsDefault?: boolean;
	ExpMonth?: number;
	ExpYear?: number;
	Last4?: string;
	State?: string;
	CreatedAt?: string;
	UpdatedAt?: string;
}
